import runPipelineInWorker from '@vibrant/core/lib/pipeline/worker/host'
import pipeline from './'

runPipelineInWorker(self, pipeline)
